

































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { log } from 'echarts/types/src/util/log';

@Component({
  components: { PagingUnit },
})
export default class CheckRectification extends Vue {
  private boardName: any = '';
  private tableData: any = [];

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  @Prop(Object) editData!: any;
  @Prop(String) currentType!: any;

  private total = 0;

  form: any = {
    name: '',
    describe: '',
    resource: '',
  };
  showDialog = false; //关联项dialog
  showCustomDialog = false; //自定义dialog
  relevanceData: any = [];
  costomTreeData: any = []; //自定义模板数据

  // diolog表格选中数据
  selectRelevanceData: any = [];

  // 外部表格选中数据
  selectOutsideRelevanceData: any = [];
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };

  gridData: any = [
    {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-04',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-01',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-03',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
  ];

  treeData: any = {
    content: '',
    typeId: '',
  };

  created() {
    this.form.name = '';
    this.form.describe = '';
    this.form.records = '';
    this.treeData.content = '';
    // console.log(this.form);
  }
  mounted() {
    console.log(this.editData);
    console.log(this.currentType);

    if (this.currentType === 'edit') {
      this.getDetail();
    }
  }

  // 如果是编辑的话，根据id获取数据
  async getDetail() {
    const res = await performanceServer.getDetail(this.editData.id);
    // console.log(res);

    if (res.code === '200') {
      res.data.checkItems.forEach((item: any) => {
        // console.log(item);
        item.bigType = item.typeInfos.length > 0 ? item.typeInfos[0].content : '';
        item.smallType = item.typeInfos.length > 1 ? item.typeInfos[1].content : '';
      });

      this.tableData = res.data.checkItems;

      console.log(this.tableData);
      this.form.name = res.data.name;
      this.form.describe = res.data.describe;
      (this.$refs.outsideTable as any).toggleAllSelection();
    } else {
      this.$message.error(res.msg);
    }
  }

  // 自定义树形表格选中事件，将多选变成单选
  handleCheckChange(data: any, checked: any) {
    if (checked) {
      // this.formData.orgId = data.id
      (this.$refs.tree as any).setCheckedKeys([data.id]);
      this.treeData.typeId = data.id;
      console.log(this.treeData.typeId);
    }
  }

  //自定义模板确定按钮
  async customConfirmBtn() {
    console.log(111);

    if (this.treeData.content == '') {
      return this.$message.warning('请输入检查模板名称');
    }
    // if (this.treeData.typeId == '') {
    //   return this.$message.warning('请选择模板类型');
    // }
    console.log(this.treeData);
    const obj: any = this.treeData;
    for (const key in obj) {
      if (!obj[key]) {
        delete obj[key];
      }
    }

    const res = await performanceServer.confrimCustomRelevanceData(obj);
    // console.log(res);
    if (res.code === '200') {
      // this.$message.success('添加成功');

      // this.tableData = res.data;

      // res.data.forEach((item: any) => {
      //   console.log(item);
      // });

      res.data.bigType = res.data.typeInfos.length > 0 ? res.data.typeInfos[0].content : '';
      res.data.smallType = res.data.typeInfos.length > 1 ? res.data.typeInfos[1].content : '';
      console.log(res.data);

      this.tableData.push(res.data);
      console.log(this.tableData);

      // 让表格全选
      (this.$refs.outsideTable as any).toggleAllSelection();

      this.showCustomDialog = false;
      this.treeData.content = '';
      // this.treeData.typeId = '';
    } else {
      this.$message.error(res.msg);
    }
  }

  // 修改数据
  async editDetail() {
    console.log(this.selectOutsideRelevanceData);

    const itemIds: any = this.selectOutsideRelevanceData.map((item: any) => item.id);

    const res = await performanceServer.editDetail(
      {
        itemIds,
        name: this.form.name,
        describe: this.form.describe,
        id: this.editData.id,
      },
      this.editData.id,
    );
    // console.log(res);
    if (res.code === '200') {
      this.$message.success('修改成功');
      this.$emit('addScuess');
    } else {
      this.$message.error(res.msg);
    }
  }
  // 新增确认
  private async confirmBtn() {
    if (!this.form.name) {
      this.$message.warning('请填写检查模板名称');
      return;
    }

    if (this.currentType === 'edit') {
      return this.editDetail();
    }
    const itemIds: any = this.selectOutsideRelevanceData.map((item: any) => item.id);

    const res = await performanceServer.addRelevanceData({
      itemIds,
      name: this.form.name,
      describe: this.form.describe,
    });

    if (res.code === '200') {
      this.$message.success('添加成功');
      this.$emit('addScuess');
    } else {
      this.$message.error(res.msg);
    }
  }
  // 点击返回按钮
  backBtn() {
    this.$emit('back');
  }

  // 删除当前行
  deleteRow(row: any) {
    // console.log(row);
    const index: number = this.tableData.findIndex((item: any) => item.id == row.id);
    // console.log(index);
    this.tableData.splice(index, 1);
  }

  // 点击新增
  handleAdd() {
    console.log('新增');
  }

  // 单选按钮点击
  async chageType() {
    // const type = this.form.resource === '关联项' ? 1 : 2;
    console.log(this.form.resource);
    if (this.form.resource === '关联项') {
      this.showDialog = true;

      // 判断有关联项表格有没有数据，如果没有则请求
      if (this.relevanceData.length == 0) {
        const res = await performanceServer.relevanceData();
        // console.log(res);
        if (res.code === '200') {
          console.log(res.data);

          res.data.forEach((item: any) => {
            // console.log(item);
            item.bigType = item.tagInfos.length > 0 ? item.tagInfos[0].name : '';
            item.smallType = item.tagInfos.length > 1 ? item.tagInfos[1].name : '';
          });

          this.relevanceData = res.data;
          // console.log(this.relevanceData);

          // this.selectRelevanceData.forEach((item: any) => {
          //   console.log(item);

          //   // (this.$refs['relevanceTable'] as any).toggleRowSelection(item, true);
          // });
        } else {
          this.$message.error(res.msg);
        }
      }
    } else {
      console.log('自定义');
      this.showCustomDialog = true;

      const res = await performanceServer.customRelevanceData({ type: 'hazardClassify' });
      console.log(res);

      this.costomTreeData = arrayToTree(res.data);
      console.log(this.costomTreeData);
    }
  }

  // 保存dialog关联项选中的表格数据
  handleSelectionChange(arr: any) {
    this.selectRelevanceData = arr;
  }

  // 保存外部中的表格数据(表格数据选中的数据)
  handleOutsideSelectionChange(arr: any) {
    this.selectOutsideRelevanceData = arr;
  }

  // 关联项表格确认
  async relevanceDataConfirmBtn() {
    // console.log(this.selectRelevanceData);
    if (this.selectRelevanceData.length === 0) {
      return this.$message.warning('请选择关联模板项');
    }

    const relationType = this.selectRelevanceData[0].relationType;
    console.log(relationType);
    // console.log(this.selectRelevanceData);

    const relationIds: any = this.selectRelevanceData.map((item: any) => item.relationId);
    // console.log(relationIds);

    const res = await performanceServer.bindRelevanceData({
      relationIds,
      relationType,
    });

    // console.log(res);
    if (res.code === '200') {
      // const arr: any = [...this.tableData, ...res.data];
      const obj: any = {};
      // for (let i = 0; i < res.data.length; i++) {
      //   if (!obj[res.data[i].key]) {
      //     this.tableData.push(res.data[i]);
      //     obj[res.data[i].key] = true;
      //   }
      // }

      // console.log(res.data);

      res.data.forEach((item: any) => {
        // console.log(item);

        item.bigType = item.typeInfos.length > 0 ? item.typeInfos[0].content : '';
        item.smallType = item.typeInfos.length > 1 ? item.typeInfos[1].content : '';
      });

      // res.data.bigType = res.data.typeInfos.length > 0 ? res.data.typeInfos[0].content : '';
      // res.data.smallType = res.data.typeInfos.length && res.data.typeInfos[1].content ? res.data.typeInfos[1].content : '';
      this.tableData = res.data;
      console.log(this.tableData);

      (this.$refs.outsideTable as any).toggleAllSelection();

      // const arr: any = [];
      // this.tableData.forEach((item: any) => {
      //   res.data.forEach((i: any) => {
      //     if (this.tableData.length > 0) {
      //       if (item.relationId !== i.relationId) {
      //         arr.push(i);
      //       }
      //     } else {
      //       arr.push(i);
      //     }
      //   });
      // });

      // this.tableData = arr;
    } else {
      this.$message.error(res.msg);
    }
    this.form.resource = '';
    this.showDialog = false;
  }

  // 树状图复选框勾选数据
  clickTap() {
    const arr: any = (this.$refs.refTree as any).getCurrentNode();
    console.log(arr, '232323');
  }

  // 关闭dialog对话框
  closeDialog() {
    this.form.resource = '';
    this.treeData.content = '';
  }
}
